import type { ContentPage } from "@/lib/content/types";

// MIGRATED (Phase 3): faithful port of the former hand-coded
// components/gitbiz/solutions/real-estate/index.jsx (rendered by the deleted
// app/(homes)/(hrms)/hrms-software/solutions/real-estate/page.jsx) onto the content
// engine (template "solution"). Copy, images, links match the original.
// SEO comes from GeneralPageSEOMetadata.json via <SEO> (its "real-estate" entry).

export const realEstate: ContentPage = {
  slug: "solutions/real-estate",
  template: "solution",
  seo: {
    title: "Real Estate Management Software | GetBiz Solutions",
    description: "Manage properties, clients, and transactions with GetBiz Solutions’ real estate software. Simplify workflows and improve productivity.",
    keywords: [
      "real estate software",
      "property management",
      "transaction management",
      "client management",
      "real estate CRM",
      "real estate solutions",
      "workflow automation",
      "property software",
    ],
    ogImage: "/assets/data/seoimages/real-estate.webp",
  },
  solution: {
    hero: {
      title: "Streamline Your Real Estate Operations with Powerful HRMS Solutions",
      description: "Your real estate business with GetBiz Solutions HRMS. Automate employee management, simplify payroll, and enhance workflow with a seamless solution built for real estate professionals.",
      image: "/assets/images/img/real_estate_solutions.webp",
      imageAlt: "real_estate_solutions",
      bgImage: "/assets/images/full-width-images/section-bg-10.jpg",
      ctaPrimary: { label: "Start 15 Days Trial", href: "/pricing/" },
      ctaSecondary: { label: "Contact Us", href: "/contactus/" },
    },
    servicesTitle: "Driving Real Estate Success with Automation",
    services: [
      { title: "Property Listings Management", description: "Automate property listing updates across multiple platforms, saving time and ensuring accuracy." },
      { title: "Lead Management", description: "Use automation to track and follow up on potential buyers, ensuring no leads fall through the cracks." },
      { title: "Client Communication", description: "Engage with clients through automated messages and reminders, improving customer satisfaction and responsiveness." },
      { title: "Contract Management", description: "Streamline contract creation and management, reducing manual tasks and increasing legal accuracy." },
      { title: "Task Automation", description: "Automate property showings, inspections, and other real estate-related tasks, ensuring efficient scheduling." },
      { title: "Customer Relationship Management", description: "Manage client relationships effectively by automating follow-ups, client history, and personalized communications." },
    ],
    ctaStrip: {
      description: "Book a personalized demo to see how our solutions can transform your business and boost your efficiency.",
      button: { label: "Book A Demo", href: "/book-demo/" },
    },
    faqDescription: "Learn how GetBiz Solutions helps real estate firms manage their operations effectively. Our FAQs cover property management, client communication, and transaction tracking tools. Discover how our platform streamlines workflows, improves client satisfaction, and provides data-driven insights to help you make informed decisions and close deals faster.",
    metaKey: "real-estate",
  },
  sections: [],
};
